import { useCallback, useRef, useState } from 'react';
import Webcam from 'react-webcam';

import _noop from '@julofinance/web-helpers/dist/fn/noop';
import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';

interface UseCameraActionOptions {
  onCameraClose: () => void;
  onCameraOpen: () => void;
}

function useCameraAction({
  onCameraClose,
  onCameraOpen,
}: UseCameraActionOptions) {
  const [imagePreview, setImagePreview] = useState('');
  const [isOpenCamera, setIsOpenCamera] = useState(false);

  const webcamRef = useRef<Webcam>(null);

  const onOpenCamera = useCallback(() => {
    setIsOpenCamera(true);
  }, []);

  const onCloseCamera = useCallback(() => {
    setIsOpenCamera(false);
    setImagePreview('');
  }, []);

  const handleCapture = useCallback(
    (onCaptureCallback: (preview: string) => void = _noop) =>
      (_: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const imageBase64 = webcamRef.current?.getScreenshot() || '';
        if (!imageBase64) return;

        setImagePreview(imageBase64);
        onCaptureCallback(imageBase64);
      },
    [],
  );

  const onReCapture = useCallback(() => {
    setImagePreview('');
  }, []);

  return {
    onOpenCamera: callAllFn(onOpenCamera, onCameraOpen),
    onCloseCamera: callAllFn(onCloseCamera, onCameraClose),
    handleCapture,
    onReCapture,
    isOpenCamera,
    webcamRef,
    imagePreview,
  };
}

export default useCameraAction;
